/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PermissionsActionResponse } from './PermissionsActionResponse';
import {
    PermissionsActionResponseFromJSON,
    PermissionsActionResponseFromJSONTyped,
    PermissionsActionResponseToJSON,
} from './PermissionsActionResponse';

/**
 * 
 * @export
 * @interface PermissionsQueryResponse
 */
export interface PermissionsQueryResponse {
    /**
     * 
     * @type {Array<PermissionsActionResponse>}
     * @memberof PermissionsQueryResponse
     */
    data: Array<PermissionsActionResponse>;
}

/**
 * Check if a given object implements the PermissionsQueryResponse interface.
 */
export function instanceOfPermissionsQueryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function PermissionsQueryResponseFromJSON(json: any): PermissionsQueryResponse {
    return PermissionsQueryResponseFromJSONTyped(json, false);
}

export function PermissionsQueryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionsQueryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(PermissionsActionResponseFromJSON)),
    };
}

export function PermissionsQueryResponseToJSON(value?: PermissionsQueryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(PermissionsActionResponseToJSON)),
    };
}

